import { InsuranceWebDto } from '@/features/dashboard/insurances/types/InsuranceWebDto.ts';

/**
 * Ubezpieczenie przypięte do wyjazdu razem ze stanem przypięcia — wycofać je
 * można na dwa sposoby i backend rozróżnia je do końca.
 */
export interface TourInsuranceAssignmentDto {
  insurance: InsuranceWebDto;
  /** Przypisanie zdjęte z tego wyjazdu; samo ubezpieczenie żyje dalej. */
  archived: boolean;
  /** Ubezpieczenie schowane w katalogu — znika z oferty każdego wyjazdu naraz. */
  insuranceArchived: boolean;
}

/**
 * Oferta ubezpieczeń wyjazdu. Operator dostaje **wszystkie** przypisania, także
 * wycofane: bez nich nie miałby czego przywrócić, a wybór uczestnika, który
 * takie ubezpieczenie ma, nie miałby jak się nazwać.
 */
export interface TourInsurancesDto {
  /** Ustawienie zapisane w konfiguracji wyjazdu — to i tylko to edytuje formularz. */
  required: boolean;
  /**
   * Wymóg po degradacji: `required` przestaje obowiązywać, gdy oferta wyjazdu
   * jest pusta (ostatnie ubezpieczenie schowano w katalogu już po konfiguracji).
   * O zachowanie — czy wolno zostać bez ubezpieczenia — pyta się **tego** pola,
   * bo to ono odpowiada backendowi (`InsuranceOfferService.effectivelyRequired`).
   */
  effectivelyRequired: boolean;
  insurances: TourInsuranceAssignmentDto[];
}

/** Ubezpieczenia realnie do wyboru: żywe przypisanie żywego ubezpieczenia. */
export const isOfferedInsurance = (
  assignment: TourInsuranceAssignmentDto,
): boolean => !assignment.archived && !assignment.insuranceArchived;
